export default __webpack_public_path__ + "static/media/mentalHealth.be1739ab.png";